


const handleValidation = value => {
    let errors = {};
    let formIsValid = true;

    //Email

    if (value.hasOwnProperty("email")) {
        if (!value["email"]) {
            formIsValid = false;
            errors["email"] = "This field is required";
        } else {
            if (typeof value["email"] !== "") {
                let lastAtPos = value["email"].lastIndexOf("@");
                let lastDotPos = value["email"].lastIndexOf(".");

                if (
                    !(
                        lastAtPos < lastDotPos &&
                        lastAtPos > 0 &&
                        value["email"].indexOf("@@") === -1 &&
                        lastDotPos > 2 &&
                        value["email"].length - lastDotPos > 2
                    )
                ) {
                    formIsValid = false;
                    errors["email"] = "Please enter a valid email Id";
                }
            }
        }
    }
    //name

    if (value.hasOwnProperty("first_name")) {
        if (!value["first_name"]) {
            formIsValid = false;
            errors["first_name"] = "This field is required";
        }
    }

    //Last Name
    if (value.hasOwnProperty("last_name")) {
        if (!value["last_name"]) {
            formIsValid = false;
            errors["last_name"] = "This field is required";
        }
    }

    //contact
    if (value.hasOwnProperty("contact")) {
        if (!value["contact"]) {
            formIsValid = false;
            errors["contact"] = "This field is required";
        }
    }

    errors["valid"] = formIsValid;
    return errors;
};
export default handleValidation;
